import PropTypes from 'prop-types';
import { defineMessages, useIntl } from 'dibs-react-intl';
import classNames from 'classnames';
import styles from '../../styles/main.scss';

// components
import { Spinner } from 'dibs-elements/exports/Spinner';
import { Button } from 'dibs-elements/exports/Button';

const messages = defineMessages({
    save: {
        id: 'dc.AddressForm.Submit.save',
        defaultMessage: 'Save',
    },
    saving: {
        id: 'dc.AddressForm.Submit.saving',
        defaultMessage: 'Saving...',
    },
});

const Submit = ({ label, wrapperClass, isSaving, disabled, onClick }) => {
    const intl = useIntl();
    const buttonClasses = classNames({
        [styles.button]: true,
        [styles.buttonDisabled]: disabled,
        [wrapperClass]: true,
    });
    return (
        <Button
            className={buttonClasses}
            disabled={disabled}
            onClick={onClick}
            dataTn={`submit${disabled ? '-disabled' : ''}`}
        >
            {isSaving && <Spinner dark containerClass={styles.inlineSpinner} />}
            {isSaving
                ? intl.formatMessage(messages.saving)
                : label || intl.formatMessage(messages.save)}
        </Button>
    );
};

Submit.propTypes = {
    label: PropTypes.node,
    wrapperClass: PropTypes.string,
    disabled: PropTypes.bool,
    isSaving: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
};

Submit.defaultProps = {
    wrapperClass: '',
    disabled: false,
    isSaving: false,
};

export default Submit;
